import { RECUPERAR_FORMA_PAGAMENTO_DESATIVADOS } from '../../actions/types'

const initialState = undefined
const estadoInicial = []

export default function reducerPagamentosDesativados (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case RECUPERAR_FORMA_PAGAMENTO_DESATIVADOS: {
      if (action.payload.data) {
        const pagamentosDesativados = action.payload.data;        
        return {
          ...state,
          pagamentosDesativados
        }
      }
      return state
    }

    default: {
      return state
    }
  }
}
